import parse from 'html-react-parser'

export const parseStringToHtml = (text: string) => {
  const parser = new DOMParser()
  const html = parser.parseFromString(text, 'text/html')
  const body = html.body.innerHTML

  return parse(body)
}
